export default "__VITE_ASSET__nLSgUXwm__"